import { usePetitionDetails } from '../../../../hooks/petitionDetails';

export function useIsIndexed(): boolean {
	const petition = usePetitionDetails();

	return petition.signatureState.signatureCount.total >= 5 && petition.discoverable;
}
